import { useState, KeyboardEvent } from "react";

interface InputProps {
  type?: "text" | "password";
  placeholder?: string;
  label?: string;
  value: string;
  onTextChange: (text: string) => void;
  height?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  multiLine?: boolean;
  className?: string;
  onKeyPress?: (
    e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

const Input = ({
  type = "text",
  placeholder,
  label,
  value,
  onTextChange,
  height,
  disabled = false,
  autoFocus = false,
  multiLine = false,
  className = "",
  onKeyPress,
}: InputProps) => {
  const [focused, setFocused] = useState(false);

  const baseClasses = `
    w-full
    rounded-3xl
    px-6
    text-lg
    font-medium
    tracking-wide
    text-[var(--text-primary)]
    placeholder-[var(--text-muted)]
    outline-none
    transition-all
    duration-300
    backdrop-blur-md
    ${focused && !disabled ? "bg-[var(--glass-bg-active)] shadow-lg scale-[1.01]" : "bg-[var(--glass-bg)] hover:bg-[var(--glass-bg-hover)] shadow-sm"}
    ${disabled ? "opacity-50 cursor-not-allowed" : ""}
  `;

  const inputClasses = `${baseClasses} ${multiLine ? "py-4 leading-relaxed resize-none" : "h-16"} ${className}`;

  return (
    <div className="w-full">
      {label && (
        <label className="block mb-2 text-sm font-medium text-[var(--text-secondary)] tracking-wide">
          {label}
        </label>
      )}
      {multiLine ? (
        <textarea
          autoFocus={autoFocus}
          onChange={(e) => onTextChange(e.target.value)}
          value={value}
          placeholder={placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          disabled={disabled}
          onKeyDown={onKeyPress}
          className={inputClasses}
          style={{ height: height || "180px" }}
        />
      ) : (
        <input
          type={type}
          autoFocus={autoFocus}
          onChange={(e) => onTextChange(e.target.value)}
          value={value}
          placeholder={placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          disabled={disabled}
          onKeyDown={onKeyPress}
          className={inputClasses}
          style={height ? { height } : undefined}
        />
      )}
    </div>
  );
};

export default Input;
